import { render, staticRenderFns } from "./MyCallsKpiCards.vue?vue&type=template&id=19edd422&scoped=true&"
import script from "./MyCallsKpiCards.vue?vue&type=script&lang=js&"
export * from "./MyCallsKpiCards.vue?vue&type=script&lang=js&"
import style0 from "./MyCallsKpiCards.vue?vue&type=style&index=0&id=19edd422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19edd422",
  null
  
)

export default component.exports